import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { Modal, Offcanvas } from "react-bootstrap";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import plusIcon from "../../../../../Assets/icons/plus-circle.svg";
import MinusIcon from "../../../../../Assets/icons/Minus-circle.svg";
import axiosInstance from "../../../../services/api/API";
import moment from "moment";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import AddIssueDynemicForm from "../../addIssueDynemicFrom";
import ReactSignatureCanvas from "react-signature-canvas";
//plus-circle.svg Minus-circle.svg
import Swal from "sweetalert2";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";

const JobCardDetails = () => {
  const location = useLocation();
  const { data } = location?.state || {};
  console.log(data, "dataofWarrantyCheck");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [jobCardDetails, setJobCardDetails] = useState([]);
  const [jobCardIssueList, setJobCardIssueList] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const token = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType");

  const [formData, setFormData] = useState({ issue_status: 0 });
  const [complainList, setComplainList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [signatureModel, setSignatureModel] = useState(false);
  const [editIssueData, setEditIssueData] = useState([]); // Add state for remark
  // const [issueId, setIssueId] = useState(0);
  const [addModel, setAddModel] = useState(false);
  const [statusValData, setStatusData] = useState();

  const [rightStatusValData, setRightStatusValData] = useState();
  const [itemSentVal, setItemSentVal] = useState();

  const [remainingDaysVal, setRemainingDaysVal] = useState(0);

  const [varientOptions, setVarientOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);

  const [editComplainData, setEditComplainData] = useState(false);

  const [editDataVal, setEditDataVal] = useState([]);

  const [partAllocationModal, setPartAllocationModal] = useState(false);

  const [compIdVal, setCompIdVal] = useState(null);

  const [itemTotalCountsVal, setItemTotalCountsVal] = useState();

  const [itemNameDD, setItemNameDd] = useState([]);

  const [compIdData, setCompIdData] = useState(null);
  const [showButton, setShowButton] = useState(true);

  const [itemCategoryOption, setItemcategoryOptions] = useState([]);

  const [itemNameData, setItemNameData] = useState([]);

  const [isChecked, setIsChecked] = useState(false);

  const [compIdList, setCompIdList] = useState([]);
  const [statusVal, setStatusVal] = useState();

  useEffect(() => {
    setShowButton(!compIdData); // show button if compIdData is null, undefined, or falsy
  }, [compIdData]);

  const [kiloMeterData, setKiloMeterData] = useState("");

  const bussness_id = data?.business_partner_id;
  // console.log(bussness_id, "businessParty")

  console.log(editIssueData, "editIssueData");

  const job_Card_id = data?.job_card_id
    ? data?.job_card_id
    : location?.state?.jobcard_id;
  const businessPartnerId = localStorage.getItem("business_partner_id");
  console.log(businessPartnerId, "businesspartnerid");
  const BUSINESSPARTNERID = location?.state?.business_partner_id;
  console.log("jobcardlocation==", job_Card_id);

  // const jobCardDetails = location.state?.jobCardDetails;

  useEffect(() => {
    // Check if jobCardDetails were passed via state from the previous component
    if (location.state?.jobCardDetails) {
      setJobCardDetails(location.state.jobCardDetails);
    }
  }, [location.state]);

  const sigCanvas = useRef();

  // useEffect(() => {
  //   setFormData({
  //     reqType:"V"
  //   })
  // },[addModel])

  //  useEffect(() => {
  //   statusDd()
  //  },[])

  //   const statusDd = async () => {
  //     try{
  //       const response = await axiosInstance.get(
  //         "/jobcard/update-jobcard-complain",

  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );

  //       const options = response.data.data.data.map((data) => ({
  //         label: data.NAME,
  //         value: data.ID,
  //       }));
  //     }catch(error){
  //       console.log(error)
  //     }
  //   }

  // const IssueInputs = [
  //   {
  //     name: "service_type",
  //     placeholder:"Enter ",
  //     type: "radio",
  //     options:[ {value: "0", label:"Free Service"}, {value: "1", label:"Paid Service"}],
  //     required: true,
  //     gridClass: "col-lg-10",

  //   },
  //   {
  //     name: "reqNumber",
  //     label:  "Enter Vin No." ,
  //     type: "servicetext",
  //     required: true,
  //     placeholder: "Enter",
  //     isComplaint: true,
  //     // options: complaintype,

  //     gridClass: "col-lg-10",
  //   },
  //   ...(kiloMeterData === null || kiloMeterData === ""
  //     ? [
  //         {
  //           name: "warrantyFrom",
  //           label: "Warranty From",
  //           placeholder: "Trans. Date",
  //           type: "date",
  //           gridClass: "col-lg-10",
  //           disabled: true,
  //         },
  //         {
  //           name: "warrantyTo",
  //           label: "Warranty To",
  //           placeholder: "Trans. Date",
  //           type: "date",
  //           gridClass: "col-lg-10",
  //           disabled: true,
  //         },
  //       ]
  //     : [
  //         {
  //           name: "kiloMeter",
  //           label: "Kilometer",
  //           type: "text",
  //           placeholder: "Kilometer",
  //           validation: { required: true },
  //           required: true,
  //           gridClass: "col-lg-10",
  //         },
  //       ]),
  //       {
  //         name: "remainingdays",
  //         label: "Remaining Days",
  //         type: "text",
  //         placeholder: "Days",
  //         disabled:"true",
  //         // validation: { required: true },
  //         // required: true,
  //         gridClass: "col-lg-10",
  //       },
  //       {
  //         name: "remark",
  //         label: "Remark",
  //         type: "text",
  //         placeholder: "Enter Description",
  //         validation: { required: true },
  //         required: true,
  //         gridClass: "col-lg-10",
  //       },
  //       {
  //         name: "uploadFile",
  //         label: "Item Screenshot",
  //         type: "file",
  //         required: true,
  //         gridClass: "col-lg-6",
  //         validation: { required: true },
  //       },
  //       {
  //         name: "status",
  //         label: "Status",
  //         type: "dropdown",
  //         required: true,
  //         placeholder: "Select Complaint",

  //         options: [
  //           { label: "Pending", value: "0" },
  //           { label: "Done", value: "1" },,
  //         ],

  //         gridClass: "col-lg-10",
  //       },

  //     ...(formData.service_type === "1"
  //         ? [
  //           {
  //             name: "claimName",
  //             label: "Complain Name",
  //             type: "text",
  //             placeholder: "Enter Description",
  //             validation: { required: true },
  //             required: true,
  //             gridClass: "col-lg-10",
  //           },

  //           // {
  //           //   name: "service_type",
  //           //   label: "Service Type",
  //           //   type: "dropdown",
  //           //   required: true,
  //           //   placeholder: "Select Service",

  //           //   options: [
  //           //     { label: "Paid Service", value: 1 },
  //           //     { label: "Free Service", value: 0 },
  //           //   ],

  //           //   gridClass: "col-lg-10",
  //           // },
  //           {
  //             name: "estCost",
  //             label: "Estimated Cost",
  //             type: "number",
  //             placeholder: "Enter Cost",
  //             validation: {
  //               required: true,
  //               pattern: /^\d+(\.\d{1,2})?$/, // Allows up to 2 decimal places
  //             message: "Only digits and up to 2 decimal places are allowed",
  //             },
  //             required: true,
  //             gridClass: "col-lg-10",
  //           },
  //           {
  //             name: "repairStatus",
  //             label: "Repair Status",
  //             type: "dropdown",
  //             required: true,
  //             placeholder: "Select Complaint",

  //             options: [
  //               { label: "Repairable", value: "repairable" },
  //               { label: "Nonrepairable", value: "nonrepairable" },,
  //             ],

  //             gridClass: "col-lg-10",
  //           },
  //           ]
  //         : []
  //     ),
  // ];

  const IssueInputs = [
    {
      name: "service_type",
      placeholder: "Enter ",
      type: "radio",
      options: [
        { value: "0", label: "Free Service" },
        // { value: "1", label: "Paid Service" },
      ],
      required: true,
      gridClass: "col-lg-10",
    },
    {
      name: "reqNumber",
      label: "Enter Vin No.",
      type: "servicetext",
      required: true,
      placeholder: "Enter",
      isComplaint: true,
      gridClass: "col-lg-10",
    },
    ...(kiloMeterData === null || kiloMeterData === ""
      ? [
          {
            name: "warrantyFrom",
            label: "Warranty From",
            placeholder: "Trans. Date",
            type: "date",
            gridClass: "col-lg-10",
            disabled: true,
          },
          {
            name: "warrantyTo",
            label: "Warranty To",
            placeholder: "Trans. Date",
            type: "date",
            gridClass: "col-lg-10",
            disabled: true,
          },
        ]
      : [
          {
            name: "kiloMeter",
            label: "Kilometer",
            type: "text",
            placeholder: "Kilometer",
            validation: { required: true },
            required: true,
            gridClass: "col-lg-10",
          },
        ]),
    {
      name: "remainingdays",
      label: "Remaining Days",
      type: "text",
      placeholder: "Days",
      disabled: true,
      gridClass: "col-lg-10",
    },
    ...(remainingDaysVal > 0 || formData.service_type === "1"
      ? [
          {
            name: "remark",
            label: "Remark",
            type: "text",
            placeholder: "Enter Description",
            validation: { required: true },
            required: true,
            gridClass: "col-lg-10",
          },
          {
            name: "status",
            label: "Status",
            type: "dropdown",
            required: true,
            placeholder: "Select Complaint",
            options: [
              { label: "Pending", value: "0" },
              { label: "Done", value: "1" },
            ],
            gridClass: "col-lg-10",
          },
        ]
      : []),

    ...(remainingDaysVal > 0 && formData.service_type === "0"
      ? [
          {
            name: "uploadFile",
            label: "Item Screenshot",
            type: "file",
            required: true,
            gridClass: "col-lg-6",
            validation: { required: true },
          },
        ]
      : []),

    ...(formData.service_type === "1"
      ? [
          {
            name: "claimName",
            label: "Complain Name",
            type: "text",
            placeholder: "Enter Description",
            validation: { required: true },
            required: true,
            gridClass: "col-lg-10",
          },
          {
            name: "estCost",
            label: "Estimated Cost",
            type: "number",
            placeholder: "Enter Cost",
            validation: {
              required: true,
              pattern: /^\d+(\.\d{1,2})?$/,
              message: "Only digits and up to 2 decimal places are allowed",
            },
            required: true,
            gridClass: "col-lg-10",
          },
          {
            name: "repairStatus",
            label: "Repair Status",
            type: "dropdown",
            required: true,
            placeholder: "Select Complaint",
            options: [
              { label: "Repairable", value: "repairable" },
              { label: "Nonrepairable", value: "nonrepairable" },
              { label: "Servicing", value: "servicing" },
            ],
            gridClass: "col-lg-10",
          },
        ]
      : []),
  ];

  // useEffect(() => {

  //   if (formData.service_type === 0) {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       estCost: "0.00",
  //     }));
  //   } else if (formData.service_type === 1){
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       estCost: "",
  //     }));
  //   }
  // },[formData.service_type])

  useEffect(() => {
    const itemNameId = formData.itemtype_id;
    const itemCategoryId = formData.category_id;
    if (itemNameId && itemCategoryId) {
      fetchItemNameDD(itemNameId, itemCategoryId);
      setItemNameDd([]);
    }
  }, [formData.itemtype_id, formData.category_id]);

  const fetchItemNameDD = async (itemNameId, itemCategoryId) => {
    try {
      // const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/item/ddlitem",
        {
          itemtype_id: parseInt(itemNameId, 10),
          category_id: itemCategoryId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setItemNameDd(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  // const handleFormSubmitPartAllocation = async (formData) => {

  //   const result = await Swal.fire({
  //     title: "Confirmation",
  //     text: "Do you want to create this record?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //   });

  //   // If the user cancels
  //   if (!result.isConfirmed) {
  //    // setLoading(false); // Stop loading state
  //     Swal.fire({
  //       title: "Cancelled",
  //       text: "Creation has been cancelled.",
  //       icon: "info",
  //       confirmButtonText: "OK",
  //     });
  //     return; // Exit the function if the user cancels
  //   }

  //   try{

  //     const payload = {
  //       job_card_id:job_Card_id,
  //       reqType: formData.itemtype_id === "1" ? "S" : "A",
  //       itemId:formData.itemId,
  //       itemCost:formData.itemCost.toString(),
  //       qty:formData.qty,
  //       remark:formData.remark
  //     }

  //     const response = await axiosInstance.patch(`/jobcard/part-allocation/${}`, payload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     // if(response.status === 200){
  //     //   setPartAllocationModal(false)
  //     //   setFormData({})
  //     // }

  //     if (response.status === 200) {
  //       Swal.fire({
  //         title: "Success",
  //         text: "Allocated Successfully",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       }).then(() => {
  //         // navigate("/admin/manage-dealer/department");
  //         setPartAllocationModal(false)
  //       setFormData({})
  //       });
  //     }

  //   }catch(error){
  //     console.log(error, "error")
  //     const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
  //       Swal.fire({
  //         title: "Something went wrong",
  //         text: errorMessage,
  //         icon: "error",
  //         confirmButtonText: "OK",
  //       });
  //   }
  // }

  const handleFormSubmitPartAllocation = async (formData, compId) => {
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Do you want to create this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    // If the user cancels
    if (!result.isConfirmed) {
      Swal.fire({
        title: "Cancelled",
        text: "Creation has been cancelled.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return; // Exit the function if the user cancels
    }

    try {
      const payload = {
        job_card_id: job_Card_id,
        reqType: formData.itemtype_id === "1" ? "S" : "A",
        itemId: formData.itemId,
        itemCost: formData.itemCost.toString(),
        qty: 1,
        remark: formData.remark,
      };

      // Ensure that the comp_id is passed in the headers
      const response = await axiosInstance.patch(
        `/jobcard/part-allocation/${compId}`, // Use the compId in the URL
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        Swal.fire({
          title: "Success",
          text: "Allocated Successfully",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setPartAllocationModal(false);
          setFormData({});
          fetchJobCardDetails();
        });
      }

      if (response.status === 200) {
        navigate("/manage-services/check-warranty");
      }
    } catch (error) {
      console.log(error, "error");
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const requestPurchaseOrder = async (formData) => {
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Do you want to create this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    // If the user cancels
    if (!result.isConfirmed) {
      // setLoading(false); // Stop loading state
      Swal.fire({
        title: "Cancelled",
        text: "Creation has been cancelled.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return; // Exit the function if the user cancels
    }

    try {
      const payload = {
        // job_card_id:job_Card_id,
        reqType: formData.itemtype_id === "1" ? "S" : "A",
        itemId: formData.itemId,
        itemCost: formData.itemCost.toString(),
        qty: formData.qty,
        remark: formData.remark,
      };

      const response = await axiosInstance.post(
        `/jobcard/request-purchase-order`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // if(response.status === 200){
      //   setPartAllocationModal(false)
      //   setFormData({})
      // }

      if (response.status === 200) {
        Swal.fire({
          title: "Success",
          text: "PO order generated succesfully Admin will get back to you",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          // navigate("/admin/manage-dealer/department");
          setPartAllocationModal(false);
          setFormData({});
        });
      }
    } catch (error) {
      console.log(error, "error");
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    setFormData({
      itemtype_id: "1",
    });
  }, [partAllocationModal]);

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
      };

      // if (userType === "superadmin") {
      //   payload.business_partner_id = formData.business_partner_id;
      // } else {
      //   payload.business_partner_id = businessPartnerId;
      // }

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    const modelId = formData.model;
    if (modelId) {
      fetchVarientOptions(modelId);
    }
  }, [formData.model]);

  const fetchVarientOptions = async (modelId) => {
    try {
      const payload = {
        page: 0,
        pageSize: 100,
        model_id: modelId,
      };

      // if (userType === "superadmin") {
      //   payload.business_partner_id = formData.business_partner_id;
      // } else {
      //   payload.business_partner_id = businessPartnerId;
      // }

      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));

      setVarientOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    fetchItemCategoryOptions();
  }, []);

  const fetchItemCategoryOptions = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/partcategory/ddlpartcategory",
        {
          // itemtype_id: itemtypeid,
          // variant_id:variantIdVal,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setItemcategoryOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  useEffect(() => {
    const itemNameId = formData.itemId;
    if (itemNameId) {
      fetchItemTotalCounts(itemNameId);
    }
  }, [formData.itemId]);

  const fetchItemTotalCounts = async (itemNameId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(
        `/jobcard/check-item-stock/${itemNameId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedCounts = response?.data?.data[0];
      console.log(fetchedCounts?.totalStock, "fetchedCounts");

      setItemTotalCountsVal(fetchedCounts?.totalStock);

      setFormData((prevData) => ({
        ...prevData,
        itemTotalCounts:
          fetchedCounts?.totalStock === 0
            ? "Out of stock"
            : fetchedCounts?.totalStock || 0,
      }));
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };

  // const fetchItemTotalCounts = async (itemNameId) => {
  //   try {
  //     const token = localStorage.getItem("authToken");
  //     const response = await axiosInstance.get(
  //       `/jobcard/check-item-stock/${itemNameId}`,
  //       {
  //         // itemtype_id: itemtypeid,
  //         // variant_id:variantIdVal,
  //        },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }

  //     );

  //     const fetchedCounts = response?.data?.data[0];
  //     console.log(fetchedCounts.totalStock, "fetchedCounts")
  //     setItemTotalCountsVal( fetchedCounts.totalStock)

  //     setFormData((prevData) => ({
  //       ...prevData,
  //       itemTotalCounts: fetchedCounts?.totalStock || 0,

  //     }));

  //   } catch (error) {
  //     console.error("Error fetching variant options:", error);
  //   }
  // };

  // useEffect(() => {
  //    setFormData((prevData) => ({
  //       ...prevData,
  //       itemTotalCounts: itemTotalCountsVal || 0,

  //     }));
  // },[formData.itemId])

  const PartAllocationInputs = [
    // {
    //   name: "itemtype_id",
    //   label: "",
    //   placeholder:"Enter ",
    //   type: "radio",
    //   options:[{value:1, label:"Spare Part"},{value:2, label:"Accessory"}],
    //   required: true,
    //   gridClass: "col-lg-12",

    // },
    {
      name: "itemtype_id",
      label: "",
      placeholder: "Enter ",
      type: "radio",
      options: [
        { value: "1", label: "Spare Parts" },
        // { value: "2", label: "Accessories" },
      ],
      required: true,
      gridClass: "col-lg-12",
    },
    {
      name: "model",
      label: "Model",
      type: "dropdown",
      options: modelOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-10",
    },
    {
      name: "variant",
      label: "Variant",
      type: "dropdown",
      required: true,
      options: varientOptions,
      validation: {
        required: true,
      },
      gridClass: "col-lg-10",
    },
    {
      name: "category_id",
      label: "Item Category",
      type: "dropdown",
      options: itemCategoryOption,
      required: true,
      placeholder: "Enter",
      // isComplaint: true,
      // options: complaintype,

      gridClass: "col-lg-10",
    },
    {
      name: "itemId",
      label: "Item Name",
      type: "dropdown",
      options: itemNameDD,
      required: true,
      placeholder: "Enter",
      // isComplaint: true,
      // options: complaintype,

      gridClass: "col-lg-10",
    },
    {
      name: "itemTotalCounts",
      label: "Item Counts",
      type: "text",
      placeholder: "Item Total Counts",
      disabled: "true",
      gridClass: "col-lg-10",
    },
    {
      name: "itemCost",
      label: "Item Cost",
      placeholder: "Enter Cost",
      type: "number",
      required: true,
      gridClass: "col-lg-10",
      validation: { required: true },
      // disabled: true,
    },
    // {
    //   name: "qty",
    //   label: "Quantity",
    //   placeholder: "Enter Quantity",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-10",
    //   validation: { required: true },
    // },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      placeholder: "Enter Remark",
      validation: { required: true },
      required: true,
      gridClass: "col-lg-10",
    },
  ];

  // const onClickSetIssueId = (id) => {
  //   if (id == "") {
  //     setIssueId("");
  //   } else {
  //     setIssueId(id);
  //   }
  // };

  const fetchJobCardIssueList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.get(
        `/jobcard/details/${data.job_card_no}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        ...item,
      }));
      setJobCardDetails(formattedData[0]);
      const statusValue = formattedData[0].is_complated;
      console.log(statusValue, "statusValue");
      setStatusVal(statusValue);

      const statusValueData = formattedData[0]?.isComplated;
      console.log(formattedData[0]?.isComplated, "statusValueData");
      setRightStatusValData(statusValueData);

      const itemSent = formattedData[0]?.itemsenttype;
      setItemSentVal(itemSent);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  useEffect(() => {
    fetchJobCardDetails();
  }, []);

  // Fetching Complain Details

  // const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
  //   if (job_Card_id !== null) {
  //     try {
  //       const response = await axiosInstance.get(
  //         `jobcard/jobcard-complain-details/${data.job_card_id}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       const formattedData = response.data.data.map((item) => ({
  //         ...item,
  //       }));
  //       setJobCardIssueList(formattedData);

  //       // Set the comp_id from the first item in the response
  //       if (formattedData.length > 0) {
  //         setCompIdVal(formattedData[0].comp_id);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching job card details:", error);
  //     }
  //   }
  // };

  // const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
  //   if (job_Card_id !== null) {
  //     try {
  //       const response = await axiosInstance.get(
  //         `jobcard/jobcard-complain-details/${data.job_card_id}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );

  //       const formattedData = response.data.data.map((item) => ({
  //         ...item,
  //       }));
  //       setJobCardIssueList(formattedData);

  //       // Extract unique comp_id values and set in state
  //       const uniqueCompIds = [...new Set(formattedData.map((item) => item.comp_id))];
  //       console.log(uniqueCompIds, "uniqueCompIds")
  //       setCompIdList(uniqueCompIds);
  //     } catch (error) {
  //       console.error("Error fetching job card details:", error);
  //     }
  //   }
  // };

  const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
    if (job_Card_id !== null) {
      try {
        const response = await axiosInstance.get(
          `jobcard/jobcard-complain-details/${data.job_card_no}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const formattedData = response.data.data.map((item) => ({
          ...item,
        }));
        setJobCardIssueList(formattedData);

        const statusVal = formattedData[0].status;
        console.log(statusVal, "statusVal");
        setStatusData(statusVal);

        // Extract unique comp_id values and set in state
        const uniqueCompIds = [
          ...new Set(formattedData.map((item) => item.comp_id)),
        ];
        console.log(uniqueCompIds, "uniqueCompIds");
        setCompIdList(uniqueCompIds); // Assuming this sets an array of unique comp_ids
      } catch (error) {
        console.error("Error fetching job card details:", error);
      }
    }
  };

  useEffect(() => {
    fetchJobCardDetails();
  }, []);

  // useEffect(() => {
  //   if (compIdVal) {
  //     fetchEditDetails();
  //   }
  // }, [compIdVal]);

  // const fetchEditDetails = async (isseDetails) => {
  //   setAddModel(true);
  //   setEditComplainData(true)

  //   try {
  //     const response = await axiosInstance.get(
  //       `jobcard/edit-jobcard-complain/${compIdVal}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //           "comp_id": compIdVal, // Add comp_id in the headers
  //         },
  //       }
  //     );

  //     const fetchedData = response?.data?.data[0]
  //     setEditIssueData(fetchedData)
  //     const compId = fetchedData.comp_id
  //     console.log(compId, "compId")
  //     setCompIdData(compId)

  //     setEditDataVal(fetchedData)

  //     console.log(fetchedData, "fetchedData")

  //     setFormData({
  //       reqNumber: fetchedData?.vinNum || fetchedData?.srNum,
  //       remark: fetchedData?.remark,
  //       warrantyFrom: fetchedData?.warrantyFrom,
  //       warrantyTo: fetchedData?.warrantyTo,
  //       claimName: fetchedData?.complainName,
  //       repairStatus: fetchedData?.repairStatus,
  //       estCost: fetchedData?.estCost,
  //       reqType: fetchedData?.vinNum ? "V" : "SA",
  //       status: "0"

  //       // technician: issueDetails?.technician_id,
  //     });

  //     // options:[{value:"V", label:"Vin No."},{value:"SA", label:"Spare Parts / Accessory"},],

  //   } catch (error) {
  //     console.error("Error fetching edit details:", error);
  //   }
  // };

  const fetchEditDetails = async (compId) => {
    setAddModel(true);
    setEditComplainData(true);
    try {
      const response = await axiosInstance.get(
        `jobcard/edit-jobcard-complain/${compId}`, // Use compId directly in the URL
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            // "comp_id": compId, // If required by the API
          },
        }
      );

      const fetchedData = response?.data?.data[0];
      setEditIssueData(fetchedData);

      setFormData({
        reqNumber: fetchedData?.vinNum || fetchedData?.srNum,
        remark: fetchedData?.remark,
        warrantyFrom: fetchedData?.warrantyFrom,
        warrantyTo: fetchedData?.warrantyTo,
        claimName: fetchedData?.complainName,
        repairStatus: fetchedData?.repairStatus,
        estCost: fetchedData?.estCost,
        reqType: fetchedData?.vinNum ? "V" : "SA",
        status: "0",
        kiloMeter: fetchedData?.kiloMeter,
        service_type: fetchedData?.service_type,
        uploadFile: fetchedData?.image_path,
      });

      console.log(`Fetched data for comp_id ${compId}:`, fetchedData);
    } catch (error) {
      console.error(
        `Error fetching edit details for comp_id ${compId}:`,
        error
      );
    }
  };

  const partAllocationDetails = async (compId) => {
    try {
      const response = await axiosInstance.get(
        `jobcard/jobcard-part-details/${compId}`, // Use compId directly in the URL
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedData = response?.data?.data;
      console.log(fetchedData, "partallocationdetails");

      setItemNameData(fetchedData);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (compIdList.length > 0) {
      compIdList.forEach((compId) => {
        partAllocationDetails(compId);
      });
    }
  }, [compIdList]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      status: "0",
    }));
  }, [addModel]);

  const handleClose = () => {
    setEditIssueData(null);
    setFormData({ issue_status: 0 });
    setAddModel(!addModel);
    setValidationErrors({});
  };

  const handleClosePartAllocation = () => {
    setPartAllocationModal(!partAllocationModal);
    // setValidationErrors({})
  };

  // useEffect(() =>{
  //   fetchComplainList()
  // },[])

  // const fetchComplainList = async (page = 0, pageSize = 1) => {
  //   try {
  //     const response = await axiosInstance.post(
  //       "/jobcard/getcustomerdetails",
  //       {
  //         business_partner_id: businessPartnerId==0?1:businessPartnerId,
  //         FilterId: null,
  //         FilterString: null,
  //         Type: "Complain",
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     const formattedData = response.data.data.map((item, index) => ({
  //       label: item?.name,
  //       value: item?.id,
  //     }));
  //     setComplainList(formattedData);
  //   } catch (error) {
  //     console.error("Error fetching business partners:", error);
  //   }
  // };

  // const handleFormSubmit = async (data) => {
  //   const errors = {};
  //   let isValid = true;

  //   IssueInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       }
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   const confirmation = await Swal.fire({
  //     title: 'Are you sure?',
  //     text: 'Do you want to save this complaint?',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'Cancel',
  //   });

  //   if (!confirmation.isConfirmed) {
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     const payload = {
  //       business_partner_id:businessPartnerId==0?1:businessPartnerId ,
  //       job_card_id: editIssueData?.job_card_id || job_Card_id || null,
  //       comp_id: editIssueData?.comp_id || null,
  //       complain_id: data?.Complain || null,
  //       complain_desc: data?.Complain_Description || null,
  //       estcost: data?.estimated_cost || null,
  //       technician_id: data?.technician || null,
  //       remark: data?.remark || null,
  //       issue_status: editIssueData ? data?.issue_status : 0,
  //       esttime: data?.east_time || null,
  //       tech_remark: null,
  //       actual_time: null,
  //       repair_id: data?.repair || null,
  //       status: 1,
  //     };

  //     const response = await axiosInstance.post(
  //       editIssueData?.comp_id
  //         ? `jobcard/add-jobcard-complain/${editIssueData?.comp_id}`
  //         : "/jobcardcomplain/create",
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (response?.status) {
  //       Swal.fire({
  //         title: 'Success!',
  //         text: editIssueData?.comp_id
  //           ? 'Complaint updated successfully.'
  //           : 'Complaint created successfully.',
  //         icon: 'success',
  //         confirmButtonText: 'OK',
  //       }).then(() => {
  //         setAddModel(false);
  //         setFormData({ issue_status: 0 });
  //         setEditIssueData(null);
  //         fetchJobCardIssueList();
  //         fetchJobCardDetails();
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching business partners:", error);
  //     Swal.fire({
  //       title: 'Error!',
  //       text: 'There was an issue saving the complaint. Please try again later.',
  //       icon: 'error',
  //       confirmButtonText: 'OK',
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const handleFormSubmit = async (data) => {
  //   const errors = {};
  //   let isValid = true;
  //   IssueInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       }
  //     }
  //   });
  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }
  //   if (editIssueData?.comp_id) {
  //     try {
  //       const response = await axiosInstance.post(
  //         "/jobcardcomplain/jobcardcomplainupdate",
  //         {
  //           business_partner_id: businessPartnerId || null,
  //           job_card_id: editIssueData?.job_card_id || null,
  //           comp_id: editIssueData?.comp_id,
  //           complain_id: data?.Complain || null,
  //           complain_desc: data?.Complain_Description || null,
  //           estcost: data?.estimated_cost || null,
  //           technician_id: data?.technician || null,
  //           remark: data?.remark || null,
  //           issue_status: data?.issue_status,
  //           esttime: data?.east_time || null,
  //           tech_remark: null,
  //           actual_time: null,
  //           repair_id: data?.repair || null,
  //           status: 1,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       if (response?.status) {
  //         setEditIssueData(null);
  //         setFormData({ issue_status: 0 });
  //         setAddModel(false);
  //         fetchJobCardIssueList();
  //         fetchJobCardDetails();
  //       }
  //     } catch (error) {
  //       console.error("Error fetching business partners:", error);
  //     }
  //   } else {
  //     try {

  //       const response = await axiosInstance.post(
  //         "/jobcardcomplain/create",
  //         {
  //           business_partner_id: businessPartnerId || null,
  //           job_card_id: job_Card_id || null,
  //           complain_id: data?.Complain || null,
  //           complain_desc: data?.Complain_Description || null,
  //           estcost: data?.estimated_cost || null,
  //           technician_id: data?.technician || null,
  //           remark: data?.remark || null,
  //           issue_status: 0,
  //           esttime: data?.east_time || null,
  //           actual_time: null,
  //           tech_remark: null,
  //           repair_id: data?.repair || null,
  //           status: 1,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );

  //       if (response?.status) {
  //         setAddModel(false);
  //         fetchJobCardIssueList();
  //         fetchJobCardDetails();
  //         setFormData({ issue_status: 0 });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching business partners:", error);
  //     }
  //   }
  // };

  // const handleFormSubmit = async (data) => {
  //   const errors = {};
  //   let isValid = true;

  //   IssueInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       }
  //     }
  //   });

  //   // Additional validation for service_type and cost
  //  if (formData.service_type === 1 && (!formData.estCost || formData.estCost === "0")) {
  //   Swal.fire({
  //     title: "Enter Cost!",
  //     text: "For Paid Service, the cost cannot be empty or zero. Please enter a valid cost.",
  //     icon: "warning",
  //     confirmButtonText: "OK",
  //   });
  //   return; // Stop further execution
  // }

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  //   const confirmation = await Swal.fire({
  //     title: 'Are you sure?',
  //     text: 'Do you want to save this complaint?',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'Cancel',
  //   });

  //   if (!confirmation.isConfirmed) {
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {

  //     const formDataPayload = new FormData();

  //     const payload = {
  //       reqType: "V",
  //       reqNum: data?.reqNumber || null,
  //       warrantyFrom: data?.warrantyFrom || null,
  //       warrantyTo: data?.warrantyTo || null,
  //       complainName: data?.claimName || null,
  //       remark: data?.remark || 0,
  //       repairStatus: data?.repairStatus || null,
  //       estCost: data.estCost || null,
  //       status: formData.status || null,
  //       kiloMeter: kiloMeterData || 0,
  //       service_type:formData.service_type,

  //       ...(editIssueData?.comp_id && { job_card_id: job_Card_id })
  //     };

  //     if (formData.uploadFile) {
  //       formDataPayload.append("uploadFile", formData.uploadFile);
  //     }

  //     const apiUrl = editIssueData?.comp_id
  //       ? `/jobcard/update-jobcard-complain/${editIssueData?.comp_id}`
  //       : `/jobcard/add-jobcard-complain/${job_Card_id }`; // No comp_id for create

  //     const response = await axiosInstance[editIssueData ? 'patch' : 'patch'](apiUrl, payload, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     if (response.status === 200){
  //       // navigate("/manage-services/check-warranty")
  //     }

  //     if (response?.status) {
  //       Swal.fire({
  //         title: 'Success!',
  //         text: editIssueData?.comp_id
  //           ? 'Complaint updated successfully.'
  //           : 'Complaint created successfully.',
  //         icon: 'success',
  //         confirmButtonText: 'OK',
  //       }).then(() => {
  //         setAddModel(false);
  //         setFormData({ issue_status: 0 });
  //         setEditIssueData(null);
  //         fetchJobCardIssueList();
  //         fetchJobCardDetails();
  //       });
  //     }
  //     setAddModel(false);
  //   } catch (error) {
  //     console.error("Error fetching business partners:", error);
  //     Swal.fire({
  //       title: 'Error!',
  //       text: 'There was an issue saving the complaint. Please try again later.',
  //       icon: 'error',
  //       confirmButtonText: 'OK',
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleFormSubmit = async (data) => {
    const errors = {};
    let isValid = true;

    IssueInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });

    // Additional validation for service_type and cost
    if (
      formData.service_type === 1 &&
      (!formData.estCost || formData.estCost === "0")
    ) {
      Swal.fire({
        title: "Enter Cost!",
        text: "For Paid Service, the cost cannot be empty or zero. Please enter a valid cost.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // Stop further execution
    }

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to save this complaint?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    setIsLoading(true);

    try {
      const formDataPayload = new FormData();

      const payload = {
        reqType: "V",
        reqNum: data?.reqNumber || 0,
        warrantyFrom: data?.warrantyFrom || 0,
        warrantyTo: data?.warrantyTo || 0,
        // complainName: data?.claimName || 0,
        complainName: data?.claimName || 0,
        remark: data?.remark || 0,
        repairStatus: data?.repairStatus || 0,
        estCost: data.estCost || 0,
        status: formData.status || 0,
        kiloMeter: kiloMeterData || 0,
        service_type: parseInt(formData.service_type, 10),
        ...(editIssueData?.comp_id && { job_card_id: job_Card_id }),
      };

      // Append all payload properties to formDataPayload
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formDataPayload.append(key, value);
        }
      });

      if (formData.uploadFile) {
        formDataPayload.append("uploadFile", formData.uploadFile);
      }

      const apiUrl = editIssueData?.comp_id
        ? `/jobcard/update-jobcard-complain/${editIssueData?.comp_id}`
        : `/jobcard/add-jobcard-complain/${job_Card_id}`; // No comp_id for create

      const response = await axiosInstance[editIssueData ? "patch" : "patch"](
        apiUrl,
        formDataPayload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // navigate("/manage-services/check-warranty")
      }

      if (response?.status) {
        Swal.fire({
          title: "Success!",
          text: editIssueData?.comp_id
            ? "Complaint updated successfully."
            : "Complaint created successfully.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setAddModel(false);
          setFormData({ issue_status: 0 });
          setEditIssueData(null);
          fetchJobCardIssueList();
          fetchJobCardDetails();
        });
      }
      setAddModel(false);
    } catch (error) {
      console.error("Error fetching business partners:", error);

      const errorVal = error?.response?.data?.message;
      Swal.fire({
        title: "Error!",
        text:
          errorVal ||
          "There was an issue saving the complaint. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const editOpenData = (issueDetails) => {
    setEditIssueData(issueDetails);
    if (issueDetails?.comp_id) {
      setFormData({
        vinNum: issueDetails?.vinNum,
        remark: issueDetails?.remark,
        warrantyFrom: issueDetails?.warrantyFrom,
        warrantyTo: issueDetails?.warrantyTo,
        claimName: issueDetails?.complainName,
        repairStatus: issueDetails?.repairStatus,
        estCost: issueDetails?.estCost,
        // technician: issueDetails?.technician_id,
      });
    }
    setAddModel(true);
  };

  const clear = () => {
    sigCanvas.current.clear();
  };

  const save = async () => {
    const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    try {
      const response = await axiosInstance.post(
        "/jobcard/jobcardsignature",
        {
          business_partner_id: businessPartnerId == 0 ? 1 : businessPartnerId,
          job_card_id: job_Card_id || null,
          signature_path: dataURL,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status) {
        setSignatureModel(false);
      }
      fetchJobCardDetails();
      fetchJobCardIssueList();
    } catch (error) {
      console.error("Error fetching business partners:", error);
    } // This will log the base64 string of the signature
  };

  useEffect(() => {
    fetchJobCardIssueList();
  }, []);

  useEffect(() => {
    if (data) {
      fetchJobCardIssueList();
      fetchJobCardDetails();
      // fetchComplainList();
    }
  }, [data]);

  // const backNavigate = () => {
  //   navigate("/manage-services/job-card");
  // };

  const apiCall = async (formData) => {
    try {
      const payload = {
        reqType: "V",
        reqNumber: formData.reqNumber,
      };

      const response = await axiosInstance.post(
        "jobcard/check-warranty",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedData = response?.data?.data[0];
      console.log(fetchedData, "fetchedData");

      const remainingDays = fetchedData.remainingDays;
      setRemainingDaysVal(remainingDays);

      const kiloMeterVal = fetchedData.kilometer;
      console.log(kiloMeterVal, "kiloMeterVal");
      setKiloMeterData(kiloMeterVal);

      setFormData((prevData) => ({
        ...prevData,
        warrantyFrom: fetchedData.warrantyFrom,
        warrantyTo: fetchedData.warrantyTo,
        kiloMeter: fetchedData.kilometer,
        remainingdays: remainingDays < 0 ? "0.00" : remainingDays, // Set to 0 if negative
      }));

      console.log(response);
    } catch (error) {
      console.log(error, "error");
    }
  };

  // const addComplain = (issueDetails) => {
  //   setEditIssueData(issueDetails)
  //   setAddModel(true)
  // }

  const backNavigate = () => {
    navigate("/manage-services/check-warranty");
  };

  const redirectionToGenerateOrder = () => {
    navigate(ROUTES_NAVIGATION.GENERATEORDER);
  };

  const handleClaimSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    IssueInputs.forEach((field) => {
      console.log("field>>", field);
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      console.log("validationErrors", validationErrors);
      return;
    }

    setIsLoading(true);
    console.log("clicked");

    const result = await Swal.fire({
      title: "Confirmation",
      text: "Do you want to claim this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    try {
      // const formDataPayload = new FormData();

      // const payload = {
      //   reqType:formData.reqType,
      //   reqNum:formData.reqNumber,
      //   warrantyFrom:formData.warrantyFrom || null,
      //   warrantyTo:formData.warrantyTo,
      //   claimName:formData.claimName,
      //   remark:formData.remark,
      //   repairStatus:formData.repairStatus,
      //   cost:formData.cost,
      //   status:0,
      //   kiloMeter: parseInt(kiloMeterData, 10)
      // }

      const formDataPayload = new FormData();

      formDataPayload.append("reqType", "V");
      formDataPayload.append("reqNum", formData.reqNumber);
      formDataPayload.append("warrantyFrom", formData.warrantyFrom);
      formDataPayload.append("warrantyTo", formData.warrantyTo);
      formDataPayload.append("claimName", formData.claimName || 0);
      formDataPayload.append("remark", formData.remark);
      formDataPayload.append("repairStatus", formData.repairStatus || 0);
      formDataPayload.append("cost", formData.estCost || 0);
      formDataPayload.append("service_type", formData.service_type);
      formDataPayload.append("status", 0);
      formDataPayload.append("kiloMeter", parseInt(kiloMeterData, 10) || 0);

      // Append file
      if (formData.uploadFile) {
        formDataPayload.append("uploadFile", formData.uploadFile);
      }

      const response = await axiosInstance.post(
        "/jobcard/create-claim-warranty",
        formDataPayload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log(response, "response")
      // if(response.status === 200){
      //   setFormData({})
      // }

      if (response.status === 200) {
        // setFormData({})
        Swal.fire({
          title: "Success",
          text: "Claimed Successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          // navigate("/admin/manage-dealer/department");
        });
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleAddComplain = () => {
    setAddModel(true);
    setEditComplainData(false);
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      reqNumber: jobCardDetails?.vin_no,
      service_type: "0",
    }));
  }, [addModel]);

  const handleSubmitFormCheckBoxEngineer = async () => {
    try {
      const response = await axiosInstance.patch(
        `/jobcard/item-sent/${data.job_card_id}`,
        {
          itemsentrecv_status: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        fetchJobCardDetails();
        fetchJobCardIssueList();
      }
      console.log("Response:", response.data);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleSubmitFormCheckBox = async () => {
    try {
      const response = await axiosInstance.patch(
        `/jobcard/item-sent/${data.job_card_id}`,
        {
          itemsentrecv_status: isChecked ? 0 : 1, // Send 0 if checked, otherwise 1
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        navigate("/manage-services/check-warranty");
      }
      console.log("Response:", response.data);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <div className="container-fuiled bg-white">
      <div className="OnboardManagamentContainer  mt-2 ">
        <span className="backbtntitle">
          <img
            src={backicon}
            alt="back"
            style={{ marginRight: 5, cursor: "pointer" }}
            onClick={() => backNavigate()}
          />
          Job Card Details
        </span>
        <div className="gap-5">
          {/* {jobCardDetails?.isgate_pass_done ===0 &&(
        <button
          className="addcustomerbutton "
          onClick={() =>
            navigate(ROUTES_NAVIGATION.SURVEY, {
              state: { productId: data?.product_id, jobCardData: data, job_Card_id:job_Card_id , bussness_id:bussness_id},
            })
          }
        >
          Survey
        </button>
        )} */}
          {/* <button
          className="addcustomerbutton "
          onClick={() =>
            navigate("survey-report", {
              state: { productId: data?.product_id, jobCardData: data },
            })
          }
        >
          Survey Report
        </button> */}
          {jobCardDetails?.isgate_pass_done === 0 && (
            <button
              className="addcustomerbutton mr-5"
              onClick={() => setSignatureModel(true)}
            >
              Signature
            </button>
          )}
        </div>
      </div>

      <div className="container-fuiled row   ">
        <div className="col-md-5 vechalDetails">
          {/* <h5 className="m-3" >Vehicle Details</h5> */}
          <div className="m-3">
            <div className="vechal-Details-SubView">
              {/* <div className="details-item">
                <span className="details-label">Customer Name</span>
                <span className="details-value">
                {jobCardDetails?.customer_name || "-"}
                  
                </span>
              </div> */}
              <div className="details-item">
                <span className="details-label">Job Card No.</span>
                <span className="details-value">
                  {jobCardDetails?.job_card_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Vin No.</span>
                <span className="details-value">
                  {jobCardDetails?.vin_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Job Type</span>
                <span className="details-value">
                  {/* {jobCardDetails?.chassis_no || "-"} */}
                  --
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Mobile No.</span>
                <span className="details-value">
                  {jobCardDetails?.contact_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Reg. No.</span>
                <span className="details-value">
                  {jobCardDetails?.registration_no || "-"}
                </span>
              </div>
              {/* <div className="details-item">
                <span className="details-label">Chassis No.</span>
                <span className="details-value">
                  {jobCardDetails?.chassis_no || "-"}
                </span>
              </div> */}
              {/* <div className="details-item">
                <span className="details-label">Engine No.</span>
                <span className="details-value">
                  {jobCardDetails?.engineno || "-"}
                </span>
              </div> */}
              <div className="details-item">
                <span className="details-label">Pin Code</span>
                <span className="details-value">
                  {jobCardDetails?.pincode || "-"}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Product Name</span>
                <span className="details-value">
                  {jobCardDetails?.product_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Sub Product Name</span>
                <span className="details-value">
                  {jobCardDetails?.subproduct_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Make</span>
                <span className="details-value">
                  {jobCardDetails?.make_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Model</span>
                <span className="details-value">
                  {jobCardDetails?.model_name || "-"}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Variant</span>
                <span className="details-value">
                  {jobCardDetails?.variant_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Variant Color</span>
                <span className="details-value">
                  {jobCardDetails?.color_name || "-"}
                </span>
              </div>
              {/* <div className="details-item">
                <span className="details-label">Fuel Type</span>
                <span className="details-value">
                  {jobCardDetails?.fuel_type_name || "-"}
                </span>
              </div> */}
              <div className="details-item">
                <span className="details-label">Warranty Start Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.warranty_startdate).format(
                    "DD/MM/YYYY"
                  ) || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty End Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.warranty_enddate).format(
                    "DD/MM/YYYY"
                  ) || "-"}
                </span>
              </div>
              {/* <div className="details-item">
                <span className="details-label">Warranty Period</span>
                <span className="details-value">
                  {jobCardDetails?.warranty_period || "-"}
                </span>
              </div> */}

              <div className="details-item">
                <span className="details-label">Service Type</span>
                <span className="details-value">
                  {jobCardDetails?.service_type || "-"}
                </span>
              </div>

              {/* <div className="details-item">
                <span className="details-label">Engineer Name</span>
                <span className="details-value">
                  {jobCardDetails?.engineer_name || "-"}
                </span>
              </div> */}

              <div className="details-item">
                <span className="details-label">Remark</span>
                <span className="details-value">
                  {jobCardDetails?.rejactRemark || "-"}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Remarks after Inspection</span>
                <span className="details-value">
                  {jobCardDetails?.eng_remark_1 || "-"}
                </span>
              </div>

              {/* <div className="details-item">
                <span className="details-label">Engineer Remark Two</span>
                <span className="details-value">
                  {jobCardDetails?.eng_remark_2 || "-"}
                </span>
              </div> */}

              <div className="details-item">
                <span className="details-label">Issue Status</span>
                <span
                  className={`details-value ${
                    jobCardDetails?.isComplated == "Pending"
                      ? "pending"
                      : "done"
                  }`}
                  style={{
                    color:
                      jobCardDetails?.isComplated === "Pending"
                        ? "red"
                        : "green",
                  }}
                >
                  {jobCardDetails?.isComplated || "-"}
                </span>
              </div>

              <div className="details-item">
                <span style={{ fontWeight: "600" }} className="details-label">
                  Jobcard Create Date
                </span>
                <span className="details-value">
                  {moment(jobCardDetails?.transaction_date).format(
                    "DD/MM/YYYY"
                  )}
                </span>
              </div>

              <div className="details-item">
                <span style={{ fontWeight: "600" }} className="details-label">
                  Dealer Warranty Date
                </span>
                <span className="details-value">
                  {jobCardDetails?.dealer_warrnty_date || "--"}
                </span>
              </div>

              {/* <div className="details-item">
                <span style={{ fontWeight: "600" }} className="details-label">
                  Engineer Assign Date
                </span>
                <span className="details-value">
                  {jobCardDetails?.assign_eng_date || "--"}
                </span>
              </div> */}
{/* 
              <div className="details-item">
                <span style={{ fontWeight: "600" }} className="details-label">
                  Item Sent Date
                </span>
                <span className="details-value">
                  {jobCardDetails?.item_sent_date || "--"}
                </span>
              </div> */}

              {/* <div className="details-item">
                <span style={{ fontWeight: "600" }} className="details-label">
                  Item Recieve Date
                </span>
                <span className="details-value">
                  {jobCardDetails?.item_recve_date || "--"}
                </span>
              </div> */}

              <div className="details-item">
                <span style={{ fontWeight: "600" }} className="details-label">
                  Job Card Done Date
                </span>
                <span className="details-value">
                  {jobCardDetails?.jobcard_done_date || "--"}
                </span>
              </div>

              <div className="details-item">
                <span style={{ fontWeight: "600" }} className="details-label"> Service Amount</span>
                <span style={{ fontWeight: "600" }} className="details-value">
                {/* paid_service_amount */}
                {data?.paid_amount || "--"}
                </span>
              </div>
              {/* <div className="details-item">
                <span style={{ fontWeight: "600" }} className="details-label"> Engineer Service Amount</span>
                <span style={{ fontWeight: "600" }} className="details-value">
                
                {jobCardDetails?.eng_paid_amount || "--"}
                </span>
              </div> */}

              <div className="details-item">
                <span style={{ fontWeight: "600" }} className="details-label">Dealer Name</span>
                <span style={{ fontWeight: "600" }} className="details-value">
                {/* paid_service_amount */}
                {jobCardDetails?.dealer_name || "--"}
                </span>
              </div>
              {/* <div className="details-item">
                <span className="details-label">Job Estimate Amt.</span>
                <span className="details-value">
                  {jobCardDetails?.job_estimate_amount || 0}
                </span>
              </div> */}

              {/* <div className="details-item">
                <span className="details-label">Job Status</span>
                <span className="details-value">
                  {jobCardDetails?.status == 0 ? "Pending" : "Done"}
                </span>
              </div> */}
              {/* <div className="details-item">
                <span className="details-label">Complain</span>
                <span className="details-value">
                  {jobCardDetails?.complaint}
                </span>
              </div> */}
              {/* <div className="details-item">
                <span className="details-label">Signature</span>
                <div style={{ display: "flex", gap: 5 }}>
                  <img
                    src={jobCardDetails?.signature_path}
                    style={{ height: 30, width: 50 }}
                  />
                  <span className="details-value">Verify</span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="col-md-7 ">
          <div className="addButtonStyle m-2">
            <h5>Issue Details</h5>
            {/* { jobCardDetails?.isgate_pass_done ===0 &&( */}
            {statusVal !== 1 ? (
              <button
                style={{ display: "none" }}
                className="addcustomerbutton"
                onClick={() => handleAddComplain()}
                // onClick={addComplain}
                // navigate("add-job-card-issue", {
                //   state: { jobCarddataId: data.job_card_id },
                // })
                // onClick(() => {})
                // setEditIssueData(issueDetails);
                // () => setAddModel(true)
              >
                Add Complain
              </button>
            ) : null}
          </div>
          <div className="issue-list-parent-container">
            {(jobCardIssueList || [])?.map((issueDetails) => (
              <div className="issue-Details-SubView">
                <div className="details-item">
                  <span className="details-label">Vin No.</span>
                  <span className="details-value">
                    {issueDetails?.vinNum || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Sr. No.</span>
                  <span className="details-value">
                    {issueDetails?.srNum || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Warranty From</span>
                  <span className="details-value">
                    {issueDetails?.warrantyFrom || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Warranty To</span>
                  <span className="details-value">
                    {issueDetails?.warrantyTo || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Jobcard Name</span>
                  <span className="details-value">
                    {issueDetails?.complainName || "-"}
                  </span>
                </div>
                {/* <div className="details-item">
                  <span className="details-label">Repair Status</span>
                  <span className="details-value">
                    {issueDetails?.repairStatus || "-"}
                  </span>
                </div> */}

                <div className="d-flex gap-2 pl-8 ">
                  <>
                    {/* { jobCardDetails?.isgate_pass_done ===0 &&( */}
                    {issueDetails?.status !== "Done" && (
                      <div
                        style={{ display: "none" }}
                        onClick={() => fetchEditDetails(issueDetails.comp_id)}
                      >
                        <img
                          src={editIcon}
                          className="accordion-icon"
                          style={{ height: 20, width: 20 }}
                        />
                      </div>
                    )}
                    {/* )} */}
                    {/* {issueDetails?.comp_id === issueId ? (
                      <div
                      // style={{display:"none"}}
                        onClick={() => {
                          onClickSetIssueId("");
                        }}
                      >
                        <img
                          src={MinusIcon}
                          //   alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                          className="accordion-icon"
                        />
                      </div>
                    ) : (
                      <div
                      // style={{display:"none"}}
                        onClick={() => {
                          onClickSetIssueId(issueDetails?.comp_id);
                        }}
                      >
                        <img
                          src={plusIcon}
                          // alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                          className="accordion-icon"
                          style={{ height: 20, width: 20 }}
                        />
                      </div>
                    )} */}
                  </>
                </div>
                {/* {issueDetails?.comp_id === issueId && ( */}
                <>
                  <div className="details-item">
                    <span className="details-label">Tech Remark</span>
                    <span className="details-value">
                      {issueDetails?.remark || "-"}
                    </span>
                  </div>

                  {/* <div className="details-item">
                      <span className="details-label">Estimate Date</span>
                      <span className="details-value">
                        {issueDetails?.esttime || 0}
                      </span>
                    </div> */}
                  {/* <div className="details-item">
                    <span className="details-label">Repair Status</span>
                    <span className="details-value">
                      {issueDetails?.repairStatus || "-"}
                    </span>
                  </div> */}
                  <div className="details-item">
                    <span className="details-label">Estimate Cost</span>
                    <span className="details-value">
                      {issueDetails?.estCost || 0}
                    </span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Type of service</span>
                    <span className="details-value">{issueDetails?.type_of_service || "--"}</span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Issue Status</span>
                    <span className="details-value">{rightStatusValData}</span>
                  </div>


                  <div style={{ display: "none" }} className="details-item">
                    <span className="details-label">Service Image</span>
                    <span className="details-value">
                      <img
                        src={issueDetails?.image_path}
                        alt="service_image"
                        style={{
                          width: "80px",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                      {/* {issueDetails?.image_path } */}
                    </span>
                  </div>
                  {/* {
                      userType === "businesspartner" && (itemSentVal === null || itemSentVal === "") ? (
                        <>
                        <div className="details-item">
                      <span className="details-label">Is Item Send</span>
                      <span className="details-value" style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="checkbox"
                          id="isItemSend"
                          name="isItemSend"
                          className="checkbox-input"
                          checked={isChecked}
                          onChange={handleCheckboxChange} // Handle checkbox state change
                        />
                        <label htmlFor="isItemSend" style={{ marginLeft: "10px" }}>
                          Yes
                        </label>
                      </span>
                    </div>

                    <div className="details-item">
                      <button onClick={handleSubmitFormCheckBox} className="submit-btn">
                        Submit
                      </button>
                    </div>
                    </>
                      ) : (
                        <div  className="details-item">
                      <span className="details-label">Item Status</span>
                      <span className="details-value">
                        {itemSentVal}
                      </span>
                    </div>
                      )
                    }

{
  userType === "engineeruser" && itemSentVal === "Item Sent" ? (
    <>
      <div className="details-item">
        <span className="details-label">Is Item Received</span>
        <span className="details-value" style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            id="isItemSend"
            name="isItemSend"
            className="checkbox-input"
            checked={isChecked}
            onChange={handleCheckboxChange} // Handle checkbox state change
          />
          <label htmlFor="isItemSend" style={{ marginLeft: "10px" }}>
            Yes
          </label>
        </span>
      </div>

      <div className="details-item">
        <button onClick={handleSubmitFormCheckBoxEngineer} className="submit-btn">
          Submit
        </button>
      </div>
    </>
  ) : null
} */}

                  {issueDetails?.repairStatus !== "Repairable" && (
                    <>
                      {userType === "businesspartner" &&
                      (itemSentVal === null || itemSentVal === "") ? (
                        <>
                          {/* <div className="details-item">
                            <span className="details-label">Is Item Send</span>
                            <span
                              className="details-value"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <input
                                type="checkbox"
                                id="isItemSend"
                                name="isItemSend"
                                className="checkbox-input"
                                checked={isChecked}
                                onChange={handleCheckboxChange} // Handle checkbox state change
                              />
                              <label
                                htmlFor="isItemSend"
                                style={{ marginLeft: "10px" }}
                              >
                                Yes
                              </label>
                            </span>
                          </div> */}

                          {/* <div className="details-item">
                            <button
                              onClick={handleSubmitFormCheckBox}
                              className="submit-btn"
                            >
                              Submit
                            </button>
                          </div> */}
                        </>
                      ) : (
                        <div className="details-item">
                          {/* <span className="details-label">Item Status</span>
                          <span className="details-value">{itemSentVal}</span> */}
                        </div>
                      )}

                      {userType === "engineeruser" &&
                      itemSentVal === "Item Sent" ? (
                        <>
                          <div className="details-item">
                            <span className="details-label">
                              Is Item Received
                            </span>
                            <span
                              className="details-value"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <input
                                type="checkbox"
                                id="isItemSend"
                                name="isItemSend"
                                className="checkbox-input"
                                checked={isChecked}
                                onChange={handleCheckboxChange} // Handle checkbox state change
                              />
                              <label
                                htmlFor="isItemSend"
                                style={{ marginLeft: "10px" }}
                              >
                                Yes
                              </label>
                            </span>
                          </div>

                          <div className="details-item">
                            <button
                              onClick={handleSubmitFormCheckBoxEngineer}
                              className="submit-btn"
                            >
                              Submit
                            </button>
                          </div>
                        </>
                      ) : null}
                    </>
                  )}

                  {/* <div style={{display:"flex", flexDirection:"row"}}> */}

                  {(itemNameData === null ||
                    (Array.isArray(itemNameData) &&
                      itemNameData.length === 0 &&
                      statusValData !== "Done")) && (
                    <div className="details-item">
                      <button
                        style={{ display: "none" }}
                        className="clear-btn"
                        onClick={() => setPartAllocationModal(true)}
                      >
                        Part Allocate
                      </button>
                    </div>
                  )}
                </>
                {/* )} */}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Modal
        show={signatureModel}
        style={{ flex: 1 }}
        onHide={() => setSignatureModel(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Verify Signature</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReactSignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{ width: 420, height: 180, className: "sigCanvas" }}
          />
        </Modal.Body>
        <Modal.Footer centered>
          <div className="downloadiconwrapper downloadIcon" onClick={clear}>
            <h6 className="downloadTitle">Clear</h6>
          </div>
          <button className="addcustomerbutton" onClick={save}>
            Verify
          </button>
        </Modal.Footer>
      </Modal>

      <Offcanvas
        placement={"end"}
        show={partAllocationModal}
        onHide={handleClosePartAllocation}
      >
        <Offcanvas.Header style={{ padding: "20px 40px" }} closeButton>
          <Offcanvas.Title>
            {/* {editIssueData?.comp_id ? "Edit Issue" : "Add Issue"} */}
            Part Allocation
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div style={{ marginTop: "-10px" }}>
            <DynamicForm
              formConfig={PartAllocationInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              // apiCall={apiCall}
            />

            <div className="col-12 ">
              <button
                disabled={itemTotalCountsVal > 0}
                onClick={() => redirectionToGenerateOrder()}
                className="clear-btn"
                style={{ marginTop: "15px", width: "85%" }}
              >
                Raise Purchase Order
              </button>
              <button
                onClick={() => {
                  const compId = compIdList[0]; // You can select a comp_id from your list as needed
                  handleFormSubmitPartAllocation(formData, compId);
                }}
                className="submit-btn"
                style={{ marginTop: "15px", width: "85%" }}
                disabled={itemTotalCountsVal === 0}
              >
                Allocate Now
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        style={{ width: "480px" }}
        placement={"end"}
        show={addModel}
        onHide={handleClose}
      >
        <Offcanvas.Header style={{ padding: "20px 70px" }} closeButton>
          <Offcanvas.Title>
            {editIssueData?.comp_id ? "Edit Issue" : "Add Issue"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ paddingLeft: "58px" }}>
          <div style={{ marginTop: "-10px" }}>
            <DynamicForm
              formConfig={IssueInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              apiCall={apiCall}
            />

            <div className="col-12 ">
              {/* {
            !editComplainData && (

                <button
                  className="clear-btn"
                  style={{ marginTop: "15px", width: "85%" }}
                  onClick={() => {
                    // handleFormSubmit(formData);
                    handleClaimSubmit(formData)
                  }}
                >
                  Claim Warranty
                </button>
            )
           }
           

      <button
        onClick={() => {
          handleFormSubmit(formData);
        }}
        className="submit-btn"
        style={{ marginTop: "15px", width: "85%" }}
      >
        Save
      </button> */}

              {formData.service_type === "1" ? (
                <>
                  <button
                    onClick={() => {
                      handleFormSubmit(formData);
                    }}
                    className="submit-btn"
                    style={{ marginTop: "15px", width: "85%" }}
                  >
                    Save
                  </button>
                </>
              ) : remainingDaysVal < 0 ? (
                <div
                  style={{
                    color: "red",
                    fontSize: "16px",
                    paddingLeft: "100px",
                    paddingTop: "20px",
                  }}
                >
                  <p>Items Out of Stock</p>
                </div>
              ) : formData.service_type === "0" && remainingDaysVal > 0 ? (
                <>
                  <button
                    className="clear-btn"
                    style={{ marginTop: "15px", width: "85%" }}
                    onClick={() => {
                      handleClaimSubmit(formData);
                    }}
                  >
                    Claim Warranty
                  </button>
                  <button
                    onClick={() => {
                      handleFormSubmit(formData);
                    }}
                    className="submit-btn"
                    style={{ marginTop: "15px", width: "85%" }}
                  >
                    Save
                  </button>
                </>
              ) : null}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default JobCardDetails;
